import { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

export const AptitudesInfoBlock: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
      <button type="button" onClick={() => setExpanded(e => !e)}
        className="w-full flex items-center gap-3 text-left">
        <HelpCircle className="w-6 h-6 text-blue-500 flex-shrink-0" />
        <span className="font-medium text-blue-800 text-base">¿Para qué sirve esta información?</span>
        <ChevronDown className={`w-5 h-5 text-blue-500 ml-auto transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <p className="mt-4 text-sm text-slate-600">
          Cuándo se necesita algo específico, es muy útil pedir apoyo a la persona indicada. Con esta
          información podremos lograr eso, multiplicando así lo que cada miembro tenga la voluntad de
          aportar.
        </p>
      )}
    </div>
  );
};
